var websock = null;
let rec;
let isConnect = false;
let socketVersion = 0;
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;
let devId = Math.floor(Math.random() * 1000000);

let connect = (wsurl, accessToken) => {
	try {
		if (isConnect && websock) {
			return;
		}
		rec && clearTimeout(rec);
		rec = null;
		console.log("连接WebSocket");
		const socket = new WebSocket(wsurl);
		const currentVersion = ++socketVersion;
		websock = socket;

		socket.onmessage = function (e) {
			if (socket !== websock || currentVersion !== socketVersion) return;
			let sendInfo = JSON.parse(e.data);
			if (sendInfo.cmd == 0) {
				heartCheck.start();
				connectCallBack && connectCallBack();
				console.log('WebSocket登录成功');
			} else if (sendInfo.cmd == 1) {
				heartCheck.reset();
			} else {
				console.log("收到消息:", sendInfo);
				messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data);
			}
		};
		socket.onclose = function (e) {
			if (socket !== websock || currentVersion !== socketVersion) return;
			console.log('WebSocket连接关闭');
			isConnect = false;
			websock = null;
			heartCheck.stop();
			closeCallBack && closeCallBack(e);
		};
		socket.onopen = function () {
			if (socket !== websock || currentVersion !== socketVersion) return;
			console.log("WebSocket连接成功");
			isConnect = true;
			const loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken,
					devId: devId
				}
			};
			socket.send(JSON.stringify(loginInfo));
		};
		socket.onerror = function (e) {
			if (socket !== websock || currentVersion !== socketVersion) return;
			console.log('WebSocket连接发生错误:{}', e);
			isConnect = false;
			heartCheck.stop();
		};
	} catch (e) {
		console.log("尝试创建连接失败");
		reconnect(wsurl, accessToken);
	}
};

let reconnect = (wsurl, accessToken, immediate = false) => {
	console.log("尝试重新连接");
	if (isConnect && websock) {
		return;
	}
	rec && clearTimeout(rec);
	if (immediate) {
		rec = setTimeout(function () {
			rec = null;
			connect(wsurl, accessToken);
		}, 0);
		return;
	}
	rec = setTimeout(function () {
		rec = null;
		connect(wsurl, accessToken);
	}, 15000);
};

let close = (code) => {
	rec && clearTimeout(rec);
	rec = null;
	heartCheck.stop();
	const socket = websock;
	websock = null;
	isConnect = false;
	socketVersion++;
	if (!socket) return;
	// 主动关闭时解除旧连接回调，避免旧连接事件覆盖新连接状态。
	socket.onopen = null;
	socket.onmessage = null;
	socket.onerror = null;
	socket.onclose = null;
	if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
		socket.close(code);
	}
};

let heartCheck = {
	timeout: 20000,
	timeoutObj: null,
	start: function () {
		if (isConnect && websock && websock.readyState === WebSocket.OPEN) {
			console.log('发送WebSocket心跳');
			const heartBeat = { cmd: 1, data: {} };
			websock.send(JSON.stringify(heartBeat));
		}
	},
	reset: function () {
		clearTimeout(this.timeoutObj);
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);
	},
	stop: function () {
		clearTimeout(this.timeoutObj);
		this.timeoutObj = null;
	}
};

let sendMessage = (agentData) => {
	if (!websock) return false;
	if (websock.readyState === websock.OPEN) {
		websock.send(JSON.stringify(agentData));
	} else if (websock.readyState === websock.CONNECTING) {
		setTimeout(function () {
			sendMessage(agentData);
		}, 1000);
	} else {
		setTimeout(function () {
			sendMessage(agentData);
		}, 1000);
	}
	return true;
};

let onConnect = (callback) => {
	connectCallBack = callback;
};

let onMessage = (callback) => {
	messageCallBack = callback;
};

let onClose = (callback) => {
	closeCallBack = callback;
};

export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
};
